import React, { useState, useEffect } from 'react';
import usePortalAuth from '../../../auth/usePortalAuth';

import { Button, Row } from 'reactstrap';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import Skeleton from '@material-ui/lab/Skeleton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LoadingSpinner } from '../LoadingSpinner/LoadingSpinner';
import ScalableShieldSpinner from '../LoadingSpinner/ScalableShieldSpinner';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import InputBase from '@material-ui/core/InputBase';
import { Box, Paper } from '@material-ui/core';
import LinkSafetyRulesTable from './LinkSafetyRulesTable';
import LinkSafetyRulesModal from './LinkSafetyRulesModal';
import useFilterForm from '../CustomHooks/useFilterForm';
import useCheckPermissionsForAPICalls from '../CustomHooks/useCheckPermissionsForAPICalls';
import useChangePageTitle from '../CustomHooks/useChangePageTitle';
import './LinkSafetyRules.css';
import basePCUrl from '../../../Globals';

const LinkSafetyRules = (props) => {
  useChangePageTitle('LinkSafetyRules');

  const [activeTab, setActiveTab] = useState('1');
  const [error, setError] = useState(false);

  const { requestType, callRoute } = useCheckPermissionsForAPICalls(props.accessLevel);

  const preferredLanguage = props.preferredLanguage
  const getTranslation = props.getTranslation

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const [values, handleFilterChange] = useFilterForm({
    filter: '',
  });

  //const [filter, setFilter] = useState('')

  const [retrievedLinkSafetyRules, setRetrievedLinkSafetyRules] = useState([]);
  const [isLoading, setLoading] = useState([]);
  const { getAccessTokenSilently } = usePortalAuth();

  const useStyles = makeStyles((theme) => ({
    root: {
      padding: theme.spacing(3),
      background: theme.palette.type === 'dark' ? theme.palette.background.default : 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
      minHeight: '100vh',
    },
    headerCard: {
      background: theme.palette.type === 'dark' ? theme.palette.background.paper : 'rgba(255, 255, 255, 0.95)',
      backdropFilter: 'blur(10px)',
      borderRadius: 16,
      border: '1px solid rgba(255, 255, 255, 0.2)',
      boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.15)',
      padding: theme.spacing(4, 3),
      marginBottom: theme.spacing(3),
      textAlign: 'center',
    },
  header: {
      fontFamily: 'Montserrat, sans-serif',
      fontWeight: 700,
      color: theme.palette.type === 'dark' ? theme.palette.text.primary : '#1a237e',
    },
    section: {
      marginBottom: theme.spacing(4),
    },
    sectionTitle: {
      fontSize: '1.3rem',
      fontWeight: 700,
      color: '#0055A2',
      marginBottom: theme.spacing(2),
    },
    spinnerContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '400px',
    },
  }));

  const classes = useStyles();

  const accountForNullData = ['nullData'];

  if (props.selectedClient === undefined || props.selectedClient === '') {
    var clientId = props.defaultClient;
  } else {
    var clientId = props.selectedClient;
  }

  const retrieveLinkSafetyRules = async () => {
    const token = await getAccessTokenSilently();
    const headers = {
      id: clientId,
      Authorization: `Bearer ${token}`,
      Action: "getLinkSafety",
      'Content-Type': 'application/json',
    };

    if (requestType != '') {
      var fetchDetails = {
        credentials: 'same-origin',
        method: 'GET',
        headers: headers,
      };


      if (requestType != '') {
        fetch(basePCUrl, fetchDetails)
          .then((response) => {
            if (response.status !== 200) {
              console.log('Looks like there was a problem. Status Code: ' + response.status);
              return;
            }

            response.json().then((data) => {
              //console.log(data);
              //console.log(data.accessLevel);
              if (data.accessLevel === 'Error') {
                setError(true);
              } else if (data === null || data === undefined) {
                setRetrievedLinkSafetyRules(accountForNullData);
              } else {
                setRetrievedLinkSafetyRules(data);

                setLoading(false);
              }
            });
          })
          .catch(function (err) {
            console.log('Fetch Error :-S', err);
          });
      }
    }
  };

  useEffect(() => {
    retrieveLinkSafetyRules();
  }, [requestType]);

  //-------Handle Search Filter-------//

  let filter = values.filter;
  const lowercasedFilter = filter.toLowerCase();

  //Filter out null values so Object.keys doesn't throw and error
  var noNullForFilter = retrievedLinkSafetyRules.map((el) => {
    return Object.keys(el).reduce((newObj, key) => {
      const value = el[key];
      if (value !== null) {
        newObj[key] = value;
      }
      return newObj;
    }, {});
  });

  const filteredData = noNullForFilter.filter((item) => {
    return Object.keys(item)
      .filter(Boolean)
      .some((key) => item[key].toString().toLowerCase().includes(lowercasedFilter));
  });

  return (
    <div className={classes.root}>
      <Paper className={classes.headerCard} elevation={0}>
        <Typography className={classes.header} variant="h3" component="h3">
          {getTranslation('Link Safety Rules', preferredLanguage)}
        </Typography>
        <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 20, gap: 16 }}>
          <div id="companyDesignationSearchForm" style={{ marginBottom: 0, paddingBottom: 0 }}>
            <InputBase
              id="companyDesignationSearchInput"
              type="text"
              placeholder="Search"
              name="filter"
              value={values.filter}
              onChange={handleFilterChange}
            />
            <Button
              id="search"
              disabled
              className={classnames({ active: activeTab === '4' })}
              onClick={() => {
                toggleTab('4');
              }}
              outline
              color="white"
            >
              <FontAwesomeIcon icon={['fas', 'search']} size="sm" />
            </Button>
          </div>
          <div className="DesignationModal">
            <LinkSafetyRulesModal
              retrieveLinkSafetyRules={retrieveLinkSafetyRules}
              requestType={requestType}
              callRoute={callRoute}
              clientId={clientId}
              accessLevel={props.accessLevel}
              preferredLanguage={preferredLanguage}
              getTranslation={getTranslation}
            />
          </div>
        </Box>
      </Paper>

      <Box className={classes.section}>
        {/* <Typography className={classes.sectionTitle}>
          {getTranslation('Your Designated Safety Rules', preferredLanguage)}
        </Typography> */}
        {isLoading ? (
          <div className={classes.spinnerContainer}>
            <ScalableShieldSpinner size={150} logoSrc={require('../../../Assets/Logos/Shield.png')} />
          </div>
        ) : (
          <LinkSafetyRulesTable
            rows={filteredData}
            retrieveLinkSafetyRules={retrieveLinkSafetyRules}
            requestType={requestType}
            callRoute={callRoute}
            clientId={clientId}
            accessLevel={props.accessLevel}
            preferredLanguage={preferredLanguage}
            getTranslation={getTranslation}
          />
        )
        }
        {error === true ? getTranslation('There was an error', preferredLanguage) + "."  : <div></div>}
      </Box>
    </div>
  );
};
export default LinkSafetyRules;

LinkSafetyRules.propTypes = {
  retrieveLinkSafetyRules: PropTypes.func,
};

//---------- Tabs Unnecessary with new table? ----------------//

//< Row className = "companyDesignationTabs" >

//    <Button className={classnames({ active: activeTab === '1' })}
//        onClick={() => { toggleTab('1'); }}
//        outline color="white" >
//        <h5>All</h5>
//    </Button>
//    <Button className={classnames({ active: activeTab === '2' })}
//        onClick={() => { toggleTab('2'); }} outline color="white" >
//        <h5>Domains</h5>
//    </Button>
//    <Button className={classnames({ active: activeTab === '3' })}
//        onClick={() => { toggleTab('3'); }} outline color="white">
//        <h5>URLs</h5>
//    </Button>

//        </Row >
